import React from "react";
import fp from "lodash/fp";
import { Row, Col } from "react-bootstrap";

import { TextWithLoader } from "components";
import { LineDivider } from "components/layout";
import { getEntityTypeName } from "mappers";
import { ViewResidualsSplitProfilesProps } from "types";

import styles from "./../splitProfile.module.scss";

const ViewPrimarySplitInfo = ({
	loading,
	splitInfo,
	title,
	indexArray,
	secondarySplitInformation,
}: ViewResidualsSplitProfilesProps) => {
	const { splitPercent, agent } = splitInfo ?? {};

	return (
		<div
			data-autotest="viewPrimarySplitInformationSection"
			className="mb-3"
		>
			<div>
				<h1 className={styles.header}>{title}</h1>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Agent:"
							value={agent?.name}
							loading={loading}
						/>
					</Col>
					<Col lg={{ span: 5, offset: 1 }}>
						<TextWithLoader
							label="Residuals Split:"
							value={
								fp.isNumber(splitPercent)
									? `${splitPercent}%`
									: ""
							}
							loading={loading}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Entity Type:"
							value={getEntityTypeName(agent?.entityType)}
							loading={loading}
						/>
					</Col>
				</Row>
				<Row>
					<Col lg={6}>
						<TextWithLoader
							label="Partner Type:"
							value={agent?.partnerTypeDisplayName}
							loading={loading}
						/>
					</Col>
				</Row>
			</div>
			{secondarySplitInformation?.length - 1 !== indexArray && (
				<LineDivider />
			)}
		</div>
	);
};

export default ViewPrimarySplitInfo;
